"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const otpMain_1 = __importDefault(require("./otpMain"));
const react_2 = require("react");
const react_3 = require("react");
const OTPInput = ({ setIsValidOTP, setOTP, OTP, verifyOTPApiResponse, sendOTPApiResponse, enableAutoReadOTP, isEmailLogin, r2d2, dataTestId, disabled, }) => {
    const [resetOTP, setResetOTP] = (0, react_3.useState)(false);
    (0, react_2.useEffect)(() => {
        if (!OTP) {
            setResetOTP(true);
            setIsValidOTP(false);
        }
        else
            setResetOTP(false);
    }, [OTP]);
    (0, react_2.useEffect)(() => {
        verifyOTPApiResponse.isVerifyOTPError && setResetOTP(true);
    }, [verifyOTPApiResponse.isVerifyOTPError]);
    (0, react_2.useEffect)(() => {
        r2d2 &&
            r2d2({
                ekind: 'otp_screen_loaded',
                edata: {
                    screen: isEmailLogin
                        ? 'email_verification_screen'
                        : 'universal_login_screen',
                    product: isEmailLogin ? 'health_gmc' : undefined,
                },
                okind: 'tracker',
            });
    }, []);
    return (react_1.default.createElement(building_blocks_ui_common_1.Flex, { justifyContent: "center" },
        react_1.default.createElement(otpMain_1.default, { autoFocus: true, isNumberInput: true, length: 4, onChangeOTP: (otp) => {
                setOTP(otp);
                if (otp.length === 4)
                    setIsValidOTP(true);
                else
                    setIsValidOTP(false);
            }, resetOTP: resetOTP, isError: verifyOTPApiResponse.isVerifyOTPError ||
                sendOTPApiResponse.isSendOTPError, enableAutoReadOTP: enableAutoReadOTP, "data-testid": dataTestId, disabled: disabled })));
};
exports.default = OTPInput;
//# sourceMappingURL=index.js.map